__turbopack_context__.v({
  "button": "IconButton-module-scss-module__owBFCa__button",
  "fade-in": "IconButton-module-scss-module__owBFCa__fade-in",
  "no-transform": "IconButton-module-scss-module__owBFCa__no-transform",
  "noShrink": "IconButton-module-scss-module__owBFCa__noShrink",
  "rotate": "IconButton-module-scss-module__owBFCa__rotate",
  "sizeLg": "IconButton-module-scss-module__owBFCa__sizeLg",
  "sizeMd": "IconButton-module-scss-module__owBFCa__sizeMd",
  "sizeSm": "IconButton-module-scss-module__owBFCa__sizeSm",
  "sizeXl": "IconButton-module-scss-module__owBFCa__sizeXl",
  "sizeXs": "IconButton-module-scss-module__owBFCa__sizeXs",
  "variantCritical": "IconButton-module-scss-module__owBFCa__variantCritical",
  "variantCta": "IconButton-module-scss-module__owBFCa__variantCta",
  "variantInverted": "IconButton-module-scss-module__owBFCa__variantInverted",
  "variantNoBg": "IconButton-module-scss-module__owBFCa__variantNoBg",
  "variantOutline": "IconButton-module-scss-module__owBFCa__variantOutline",
  "variantOutlineInverted": "IconButton-module-scss-module__owBFCa__variantOutlineInverted",
  "variantPrimary": "IconButton-module-scss-module__owBFCa__variantPrimary",
  "variantSecondary": "IconButton-module-scss-module__owBFCa__variantSecondary",
});
